import { FunctionComponent, useCallback } from 'react'
import Modal from '@/components/Modal'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useRealtimeAttendanceContext } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import { Text } from '@conexasaude/conexa-hero'
import { useStyles } from './styles'
import { useCallMonitoringStore } from '@/modules/VideoCall/store/call-monitoring-store'

const ScheduledCallStartedModal: FunctionComponent<{
  hookSuccess()
}> = ({ hookSuccess }) => {
  const { closeModal } = useModalContext()
  const {
    realtimeAttendance: { nextScheduled },
  } = useRealtimeAttendanceContext()
  const styles = useStyles()

  const realtimeAppointmentCall = useCallMonitoringStore(state => state.call)

  const goAppointmentScheduled = useCallback(() => {
    closeModal()
    hookSuccess()
  }, [closeModal, hookSuccess])

  return (
    <Modal
      id="SCHEDULED_CALL_STARTED"
      primaryActionLabel="Iniciar consulta"
      primaryAction={goAppointmentScheduled}
      primaryActionId="SalaDeEsperaAgendado-IniciarConsulta-CTA_IniciarConsulta"
    >
      <div css={styles.wrapperModal}>
        <Text>
          <Text renderAs="span">
            {realtimeAppointmentCall
              ? realtimeAppointmentCall?.additionalInfo?.professionalName
              : nextScheduled?.professionalName?.toLowerCase()}
          </Text>{' '}
          já está aguardando por você. Vamos começar?
        </Text>
      </div>
    </Modal>
  )
}

export default ScheduledCallStartedModal
